/* eslint-disable no-restricted-imports */
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { Button } from '@frontend/components';

import { formatPrice } from 'utils/formatters';

import { useCreateOrder } from '../../data/hooks';
import {
  getAreAdjustmentsAndAdditionalChargesValid,
  getNumberOfSelectedParts,
  getSubtotalCost,
  getIsSettingOptions,
} from '../../data/reducer';

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;
`;

const FooterSelectionDisplay = styled.div`
  display: flex;
  flex-direction: column;
`;

const PartsSelected = styled.div`
  color: #222;
  font-family: 'Libre Franklin';
  font-size: 12px;
`;

const SubTotal = styled.div`
  color: #222;
  font-family: 'Libre Franklin';
  font-size: 14px;
  font-weight: 700;
`;

const PartSelectionFooter = () => {
  const areAdjustmentsAndAdditionalChargesValid = useSelector(
    getAreAdjustmentsAndAdditionalChargesValid,
  );
  const isSettingOptions = useSelector(getIsSettingOptions);
  const numberOfSelectedParts = useSelector(getNumberOfSelectedParts);
  const subTotal = useSelector(getSubtotalCost);

  const create = useCreateOrder();

  return (
    <Footer>
      {numberOfSelectedParts > 0 ? (
        <FooterSelectionDisplay>
          <PartsSelected>{`${numberOfSelectedParts} PARTS SELECTED`}</PartsSelected>
          <SubTotal>{`${formatPrice(subTotal, 2)} Subtotal`}</SubTotal>
        </FooterSelectionDisplay>
      ) : (
        <div />
      )}
      <Button
        variant="primary"
        isDisabled={
          numberOfSelectedParts === 0 ||
          !areAdjustmentsAndAdditionalChargesValid ||
          isSettingOptions
        }
        isLoading={isSettingOptions}
        onClick={create}
      >
        CREATE ORDER
      </Button>
    </Footer>
  );
};

export default PartSelectionFooter;
